import React from "react";

import {
  IonButtons, IonHeader, IonTitle, IonToolbar, IonContent,
  IonButton, IonModal, IonIcon, IonAlert, IonProgressBar, IonFabList,
  IonFabButton, IonFab
} from "@ionic/react";
import {trash, create} from "ionicons/icons";
import {AppState} from "../models/app";
import {AppDispatch, RootState} from "../global.state";
import {connect} from "react-redux";
import classNames from "classnames";


interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: any;
  entityLabel: string;
  gender: 'm' | 'f';
  ModelForm: any;
  modelFormProps?: any;
  onReload?: (changed:boolean) => void;
  onDelete?: () => void;
  allowDelete?: boolean;
  allowEdit?: boolean;
  classname?: string;
  modalNoPadding?: boolean;
}

interface State {
  modelFormVisible: boolean;
  confirmarExclusaoVisible: boolean;
}

class EntityView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modelFormVisible: false,
      confirmarExclusaoVisible: false,
    };
  }

  public static defaultProps = {
    allowEdit: true,
    allowDelete: true,
  };

  onClickAlterar = () => {
    this.setState({
      modelFormVisible: true,
    });
  };

  onSubmit = () => {
    this.setState({modelFormVisible: false});
    this.props.onReload && this.props.onReload(true);
  };

  onClickExcluir = () => {
    this.setState({confirmarExclusaoVisible: true});
  };

  onCloseExcluir = () => {
    this.setState({confirmarExclusaoVisible: false});
  };

  onConfirmExcluir = () => {
    if (!this.props.onDelete)
      throw Error('Undefined onDelete callback.');
    this.props.onDelete();
  };

  render() {
    const {ModelForm} = this.props;
    const modelFormProps = this.props.modelFormProps || {};

    return (
      <>
        {
          !this.props.instance && <IonProgressBar type="indeterminate"/>
        }

        {
          this.props.instance &&
          <>
            {
              (this.props.allowEdit || this.props.allowDelete) &&
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                  <IonFabButton color="secondary">
                    <IonIcon icon={create}/>
                  </IonFabButton>

                  <IonFabList side="top">
                    {
                      this.props.allowEdit &&
                      <IonFabButton color="success" onClick={this.onClickAlterar}>
                        <IonIcon icon={create}/>
                      </IonFabButton>
                    }
                    {
                      this.props.allowDelete &&
                      <IonFabButton color="danger" onClick={this.onClickExcluir}>
                        <IonIcon icon={trash}/>
                      </IonFabButton>
                    }
                  </IonFabList>
                </IonFab>
            }

            <div className={classNames("ion-padding", this.props.classname)}>
              {this.props.children}
            </div>
          </>
        }

        {
          this.props.instance &&
          <IonModal
            isOpen={this.state.modelFormVisible}
            onDidDismiss={() => this.setState({modelFormVisible: false})}
            key={this.props.instance.id}
          >
            <IonHeader>
              <IonToolbar>
                <IonTitle>
                  Cadastro {this.props.entityLabel.toLowerCase()}
                </IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() => this.setState({modelFormVisible: false})}
                  >
                    Cancelar
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>

            <IonContent
              className={classNames({'ion-padding': !this.props.modalNoPadding})}
            >
              <ModelForm
                instance={this.props.instance}
                onSubmit={this.onSubmit}
                {...modelFormProps}
              />
            </IonContent>
          </IonModal>
        }

        <IonAlert
          isOpen={this.state.confirmarExclusaoVisible}
          header="Atenção"
          message="Você tem certeza que deseja remover este registro?"
          onDidDismiss={this.onCloseExcluir}
          buttons={[
            {
              role: 'cancel',
              text: 'Cancelar',
            },
            {
              role: 'ok',
              text: 'Excluir mesmo',
              handler: () => {
                this.onConfirmExcluir()
              }
            }
          ]}
        />
      </>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(EntityView);